import {IEnvironment} from 'frontier/nucleus';

export const environment: IEnvironment = {
  env: 'prod',
  buildNumber: 531,
  buildHash: '60155298653f2eae88df8cc18e7499321ab5136a',
};
